module.exports = __webpack_public_path__ + "img/user.455252a0.png";